import { tickerItems } from "@/mocks/home";

export default function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="bg-primary-500 text-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="h-11 flex items-center gap-4 overflow-hidden">
          <span className="hidden sm:flex items-center gap-1.5 shrink-0 text-xs font-label font-bold tracking-wide whitespace-nowrap">
            <i className="ri-radar-line text-base" aria-hidden="true" />
            实时速递
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex items-center gap-8 w-max">
              {loop.map((item, index) => (
                <a
                  key={`${item}-${index}`}
                  href="#live"
                  className="flex items-center gap-2 text-sm whitespace-nowrap cursor-pointer transition-opacity hover:opacity-80"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50/80" aria-hidden="true" />
                  {item}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}